import { useEffect, useState } from 'react';
import { Loader2, X } from 'lucide-react';
import { normalizeCapturedWhatsapp } from '../../utils/marketingApi';
import s from './CapturedWhatsappModal.module.scss';

export default function CapturedWhatsappModal({
  isOpen,
  onClose,
  dialedPhone = '',
  initialCaptured = '',
  busy = false,
  onConfirm,
}) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setValue(initialCaptured || '');
    setError(null);
  }, [isOpen, initialCaptured]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    const wa = normalizeCapturedWhatsapp(value);
    if (!wa) {
      setError('Enter a valid 10-digit WhatsApp number.');
      return;
    }
    setError(null);
    onConfirm?.(wa);
  };

  return (
    <div className={s.overlay} onClick={onClose} role="presentation">
      <div
        className={s.panel}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={s.head}>
          <h2>Captured WhatsApp number</h2>
          <button type="button" className={s.close} onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <p className={s.hint}>
          Create the customer on the captured WhatsApp number — not the dialed non-WA number.
        </p>
        <label className={s.field}>
          <span>Dialed (non-WA)</span>
          <input readOnly className={s.readonly} value={dialedPhone || '—'} />
        </label>
        <label className={s.field}>
          <span>Captured WhatsApp number *</span>
          <input
            autoFocus
            placeholder="10-digit mobile"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
          />
        </label>
        {error ? <div className={s.error}>{error}</div> : null}
        <div className={s.actions}>
          <button type="button" className={s.ghost} onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className={s.primary} onClick={handleSubmit} disabled={busy}>
            {busy ? <Loader2 size={16} className="spin" /> : null}
            {busy ? 'Creating…' : 'Create customer'}
          </button>
        </div>
      </div>
    </div>
  );
}
